import React, { useEffect } from 'react'
import Methodik from '../methodik'
import './styles.scss'

function UsWidgets(props) {
  // let params = new URL(window.location).searchParams
  // let type = params.get('type')

  useEffect(() => {
    const script = document.createElement('script')

    script.src = 'https://dpa-infocom.s3-eu-west-1.amazonaws.com/js/dpa.js'
    script.async = true

    document.body.appendChild(script)
  })

  let subtitleClass = false

  if (props.subtitle !== '') {
    subtitleClass = true
  }


  if (props.chartType === 'senat') {
    return (
      <div className='dpaChart'>
        <div className='titleContainer'>
          <h3 className='ui header small infographic chart'>{props.title}</h3>
          <div className='ta text subline'>
            <p>{props.graphicText}</p>
          </div>
        </div>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='pym'
            data-competition-id='pw_us'
            data-language='de'
            data-standalone='congress'
            data-election-type='senate'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2020/resultate-us-praesidentenwahl/senat/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/praesidentschaftswahl-usa2020/aws/dpa-shop/html/index.html?language=de&customer=tamedia&triggerSeatsCompare=true'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/pw_us/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'repraesentantenhaus') {
    return (
      <div className='dpaChart'>
        <div className='titleContainer'>
          <h3 className='ui header small infographic chart'>{props.title} </h3>
          {/* <div
              className={
                subtitleClass ? 'chartSubtitle subtitleClass' : 'chartSubtitle'
              }
            >
              {props.subtitle}
            </div> */}
          <div className='ta text subline'>
            <p>{props.graphicText}</p>
          </div>
        </div>
        <div className='widgetWrapper'>
          <div
            data-app='dpa-electionslive'
            data-embed-type='pym'
            data-competition-id='pw_us'
            data-language='de'
            data-standalone='congress'
            data-election-type='house'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2020/resultate-us-praesidentenwahl/repraesentantenhaus/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/praesidentschaftswahl-usa2020/aws/dpa-shop/html/index.html?language=de&customer=tamedia&triggerSeatsCompare=true'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/pw_us/'
          />
        </div>
      </div>
    )
  }

  if (props.chartType === 'kombination-wahlmaenner-karte') {
    return (
      <div>
        <div className='dpaChart'>
          <h3
            className='ui header small infographic chart'
            style={{ marginBottom: '0.5rem' }}
          >
            {props.title}
          </h3>
          {/* <div
            className={
              subtitleClass ? 'chartSubtitle subtitleClass' : 'chartSubtitle'
            }
          >
            {props.subtitle}
          </div> */}
          <div
            data-app='dpa-electionslive'
            data-embed-type='pym'
            data-competition-id='pw_us'
            data-language='de'
            data-standalone='votingAreas'
            data-phase='election'
            data-view='map'
            data-path-css='https://interaktiv.tagesanzeiger.ch/2020/resultate-us-praesidentenwahl/kombination-wahlmaenner-karte/'
            data-custom-font='true'
            data-widget-header='false'
            data-src='https://d3ak46ifsn9mnh.cloudfront.net/customers/praesidentschaftswahl-usa2020/aws/dpa-shop/html/index.html?language=de&customer=tamedia&displayTrendButton=true'
            data-path='https://d3ak46ifsn9mnh.cloudfront.net/pw_us/'
          />
          {/* <Methodik title='Informationen zur Grafik'>
          <p>
            <b>
              Der Präsident wird nicht direkt vom Volk gewählt, sondern durch
              538 Wahlmänner und -frauen.
            </b>{' '}
            Jeder Bundesstaat stellt davon nach Bevölkerungsgrösse eine
            bestimmte Anzahl. Der Kandidat mit den meisten Wählerstimmen im
            Bundesstaat verbucht sämtliche Wahlmänner des Staates für sich. In
            {' '}<b>Maine</b> und <b>Nebraska</b> werden die Stimmen der Wahlleute nach Mehrheiten in
            den Wahlbezirken aufgeteilt. Der Gesamtsieger des Staates erhält zwei weitere Stimmen.
          </p>
        </Methodik> */}
        </div>
      </div>
    )
  }
  return false
}

export { UsWidgets }
